module.exports = __webpack_public_path__ + "img/2.a071ac7b.png";